import { useEffect, useState } from 'react';
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import { useMediaQuery } from '@mui/material';
import { ReactComponent as Facebook } from '../assets/facebook.svg';
import { ReactComponent as Instagram } from '../assets/instagram.svg';
import { ReactComponent as Pinterest } from '../assets/pinterest.svg';
import { ReactComponent as Search } from '../assets/search.svg';
import { ReactComponent as Youtube } from '../assets/youtube.svg';
import { ReactComponent as BurgerOpen } from './burger-open.svg';
import { ReactComponent as Heart } from './heart.svg';
import clsx from 'clsx';
import style from './style.module.scss';
import { useTranslation } from 'react-i18next';

const LangSwitch = ({ activeLang, languages }) => {
    return (
        <ul className={style.langSwitch}>
            {languages.map((language) => (
                <li
                    key={language.code}
                    className={clsx(style.lang, language.code === activeLang && style.current)}
                >
                    <a href={language.url} title={language.native_name}>
                        {language.code}
                    </a>
                </li>
            ))}
        </ul>
    );
};

const Origin = () => {
    const { t } = useTranslation();

    return (
        <div className={style.origin}>
            <div className={style.flag}></div>
            <p>{t('Créateur et fabricant français depuis 1960')}</p>
        </div>
    );
};

const SocialLinks = ({ settings }) => [
    settings.facebookUrl && (
        <a href={settings.facebookUrl} target="_blank" rel="noreferrer">
            <Facebook className={style.icon} />
        </a>
    ),
    settings.instagramUrl && (
        <a href={settings.instagramUrl} target="_blank" rel="noreferrer">
            <Instagram className={style.icon} />
        </a>
    ),
    settings.pinterestUrl && (
        <a href={settings.pinterestUrl} target="_blank" rel="noreferrer">
            <Pinterest className={style.icon} />
        </a>
    ),
    settings.youtubeUrl && (
        <a href={settings.youtubeUrl} target="_blank" rel="noreferrer">
            <Youtube className={style.icon} />
        </a>
    ),
];

const Menu = ({ menu, settings, activeLang, languages }) => {
    const isTablet = useMediaQuery(`(max-width:${style.tabletBreakpoint})`);

    return (
        <ul className={style.mainMenu}>
            {menu.map((men) => (
                <li key={men.ID}>
                    <a href={men.url}>{men.post_title || men.title}</a>
                    {men.children?.length > 0 && (
                        <ul>
                            {men.children.map((submenu) => (
                                <li key={submenu.ID}>
                                    <a href={submenu.url}>{submenu.post_title || submenu.title}</a>
                                </li>
                            ))}
                        </ul>
                    )}
                </li>
            ))}
            {isTablet && (
                <li className={style.mobileSocial}>
                    <Origin />
                    <LangSwitch activeLang={activeLang} languages={languages}  />
                    <SocialLinks settings={settings} />
                </li>
            )}
        </ul>
    );
};

const Header = ({ logo, menu, settings, activeLang, languages, home }) => {
    const { t } = useTranslation();
    const isTablet = useMediaQuery(`(max-width:${style.tabletBreakpoint})`);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : '';
    }, [menuOpen]);

    return (
        <BlockWrapper.Header className={style.header}>
            <div className={style.head}>
                {!isTablet && <Origin />}
                <a href={home}>
                    <img src={logo} className={style.logo} alt="Logo Galipette" />
                </a>
                {!isTablet && (
                    <div className={style.shortcuts}>
                        <LangSwitch activeLang={activeLang} languages={languages} />
                        <div className={style.social}>
                            <SocialLinks settings={settings} />
                        </div>
                    </div>
                )}
            </div>
            <div className={style.menu}>
                <div className={clsx(style.menuLeft, menuOpen && style.open)}>
                    <Menu menu={menu} settings={settings} activeLang={activeLang} languages={languages} />
                </div>

                <BurgerOpen
                    className={style.burger}
                    onClick={() => setMenuOpen(!menuOpen)}
                />

                <div className={style.menuRight}>
                    <span data-toggle="modal" data-target="#modalBabylist">
                        <Heart /> {t('Ma babylist')}
                    </span>
                    {settings.espaceproUrl && (
                        <a href={settings.espaceproUrl}>{t('Espace pro')}</a>
                    )}
                    <span class="link-search">
                        <Search className={style.search} />
                    </span>
                </div>
            </div>
        </BlockWrapper.Header>
    );
};

export default defineBlock({
    Block: Header,
    setup: {
        title: 'Header',
    },
});
